import { ScrollToTopConstants } from './scrollToTop.constants'
import { IScrollToTopActions, IScrollToTopState } from './scrollToTop.types'

export const initialScrollToTopState: IScrollToTopState = {
  currentY: 0,
  isVisible: false,
  scrollTargetID: '',
}

export function scrollToTopReducer(
  state: IScrollToTopState = initialScrollToTopState,
  action: IScrollToTopActions
): IScrollToTopState {
  switch (action.type) {
    case ScrollToTopConstants.SET_IS_VISIBLE:
      return { ...state, currentY: action.currentY, isVisible: action.currentY > 40 }
    case ScrollToTopConstants.SET_SCROLL_TARGET_ID:
      return { ...state, scrollTargetID: action.scrollTargetID }
    default:
      return state
  }
}
